/* DON'T EDIT THIS FILE: edit original and run build again */ import { InputElement, InputElementProps } from "./input-element.tsx";

type InputProps = Omit<InputElementProps, "type">;

export const TextInput = (props: InputProps) => (
  <InputElement {...props} type="text" />
);
